import React ,{useEffect} from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Select from "react-select";
import Line from "../../../components/Line/Line";
import { useForm, Controller } from "react-hook-form";
import {
  useGetLocationList,
  useGetDepartmentList,
  useGetDesignationList,
  useGetEmployeeTypeList,
  useGetLineManagerList,
  useGetJobTitleList,
  useUpdateEmployeeInformation,
  useAssignLineManager,
} from "../../../queries/employeeQueries";
import { toast } from "react-toastify";

const EditOrAddPosition = ({ openModal, onCloseModal, employee }) => {

  const { register, handleSubmit, control, reset } = useForm({
    mode: "onBlur",
    defaultValues: {
      designation_id: employee?.designation_id || "",
      location_id: employee?.location_id || "",
      employee_type_id: employee?.employee_type_id || "",
      department_id: employee?.department_id || "",
      line_manager_id: employee?.line_manager_id || "",
    },
  });

  const { data: locationData } = useGetLocationList();
  const { data: departmentData } = useGetDepartmentList();
  const { data: designationData } = useGetDesignationList();
  const { data: employeeTypeData } = useGetEmployeeTypeList();
  const { data: managerData } = useGetLineManagerList();
  const { data: jobTitleData } = useGetJobTitleList();

  const locationList = locationData?.result || [];
  const departmentList = departmentData?.result || [];
  const designationList = designationData?.result || [];
  const employeeTypeList = employeeTypeData?.result || [];
  const managerList = managerData?.result || [];
  const jobTitleList = jobTitleData?.result || [];
  const updateEmployeeMutation = useUpdateEmployeeInformation();
  const assignLineManagerMutation = useAssignLineManager();

  useEffect(() => {
    if (employee) {
      reset({
        designation_id: employee?.designation_id || "",
        location_id: employee?.location_id || "",
        employee_type_id: employee?.employee_type_id || "",
        department_id: employee?.department_id || "",
        line_manager_id: employee?.line_manager_id || "",
      });
    }
  }, [employee, reset]);

 const onSubmit = async (formData) => {
  try {
    const updates = {};
    const { line_manager_id, ...otherFields } = formData;

    // Compare form data with the current employee data
    Object.keys(otherFields).forEach((key) => {
      if (employee[key] !== otherFields[key] && otherFields[key] !== "") {
        updates[key] = otherFields[key];
      }
    });

    const apiCalls = [];

    // If designation or any other detail changed → update employee info
    if (Object.keys(updates).length > 0) {
      console.log("Updating employee fields:", updates);
      apiCalls.push(
        updateEmployeeMutation.mutateAsync({
          employeeId: employee.employee_id,
          ...updates,
        })
      );
    }

    // If line manager changed → call line manager API
    if (line_manager_id && line_manager_id !== employee.line_manager_id) {
      console.log("Updating Line Manager:", line_manager_id);
      apiCalls.push(
        assignLineManagerMutation.mutateAsync({
          employeeList: [
            {
              employeeId: employee.employee_id,
              lineManagerId: line_manager_id,
            },
          ],
        })
      );
    }

    // Run all relevant API calls in parallel
    if (apiCalls.length > 0) {
      await Promise.all(apiCalls);
      toast.success("Employee information updated successfully!");
    } else {
      toast.info("No changes detected.");
    }

    onCloseModal();
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong while updating employee data");
    onCloseModal();
  }
};

  
  
  

  return (
    <Modal open={openModal} onClose={onCloseModal} center>
      <div className="p-5 w-[520px]">
        <h2 className="text-lg leading-6 text-[#1F2937] font-semibold mb-5">
          Edit/Add Position
        </h2>
        <form
          className="flex flex-col gap-4 justify-center"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex flex-col">
            <label className="text-sm font-medium text-black">
              Location <span className="text-red-700"></span>
            </label>
            <Controller
              name="location_id"
              control={control}
              render={({ field: { onChange } }) => (
                <Select
                  placeholder={employee?.office_location || "Select"}
                  options={locationList}
                  getOptionLabel={(option) => option.location_name}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => onChange(Number(e.id))}
                />
              )}
            />
          </div>

          <div className="flex justify-between">
            <div className="flex w-full flex-col">
              <label className="text-sm font-medium text-black">
                Position Type <span className="text-red-700"></span>
              </label>
              <input
                type="text"
                className="max-w-[220px]"
                value={employee?.user_role_label || ""}
                disabled
              />
            </div>

            <div className="flex w-full flex-col">
              <label className="text-sm font-medium text-black">
                Employment Type <span className="text-red-700"></span>
              </label>
              <Controller
                name="employee_type_id"
                control={control}
                render={({ field: { onChange } }) => (
                  <Select
                    placeholder={employee?.employee_type_label || "Select"}
                    options={employeeTypeList}
                    getOptionLabel={(option) => option.type_label}
                    getOptionValue={(option) => option.id}
                    onChange={(e) => onChange(Number(e.id))}
                  />
                )}
              />
            </div>
          </div>

          <div className="flex justify-between gap-5">
            <div className="flex flex-col w-full">
              <label className="text-sm font-medium text-black">
                Designation <span className="text-red-700"></span>
              </label>
              <Controller
                name="designation_id"
                control={control}
                render={({ field: { onChange } }) => (
                  <Select
                    placeholder={employee?.designation_title || "Select"}
                    options={designationList}
                    getOptionLabel={(option) => option.designation_title}
                    getOptionValue={(option) => option.id}
                    onChange={(e) => onChange(Number(e.id))}
                  />
                )}
              />
            </div>

            <div className="flex w-full flex-col">
              <label className="text-sm font-medium text-black">
                Department <span className="text-red-700"></span>
              </label>
              <Controller
                name="department_id"
                control={control}
                render={({ field: { onChange } }) => (
                  <Select
                    placeholder={employee?.department_name || "Select"}
                    options={departmentList}
                    getOptionLabel={(option) => option.department_name}
                    getOptionValue={(option) => option.id}
                    onChange={(e) => onChange(Number(e.id))}
                  />
                )}
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-black">
              Line Manager <span className="text-red-700"></span>
            </label>
            <Controller
              name="line_manager_id"
              control={control}
              render={({ field: { onChange } }) => (
                <Select
                  placeholder={employee?.line_manager_name || "Select"}
                  options={managerList}
                  getOptionLabel={(option) => option.line_manager_name}
                  getOptionValue={(option) => option.id}
                  onChange={(selectedOption) => onChange(selectedOption.id)}
                />
              )}
            />
          </div>

          <Line width={""} />

          <div className="flex justify-end gap-3 mr-5">
            <button
              type="button"
              className="btn btn--border text-sm font-medium"
              onClick={onCloseModal}
            >
              Cancel
            </button>
            <button type="submit" className="btn text-sm font-medium">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditOrAddPosition;
